import {
  type AclConfig,
  type MenuElement,
} from '@store/skeletor/permissions/types';

export const mergeRoleMenus = (roles: AclConfig[]): MenuElement[] => {
  const menus = roles.map(role => role.menu);

  const mergeMenu: MenuElement[] = menus.reduce((acc, menu) => {
    const paths = acc.map(menu => menu.path);

    const newItems = menu.filter(menu => !paths.includes(menu.path));

    return acc.concat(...newItems);
  }, []);

  return mergeMenu;
};
